import type { PropsWithChildren } from 'react';
import { MobileOnlyLogo } from './Branding';
import { StepText, Title } from './Form.styles';

export const FormTitleAndLogo = ({ children }: PropsWithChildren) => (
  <>
    <MobileOnlyLogo />
    <Title variant="h4" component="h1">
      {children}
    </Title>
  </>
);

export const FormStep = ({ children }: PropsWithChildren) => <StepText variant="body1">{children}</StepText>;
